<template>
  <div id="aso">
    <headerbom :hdtitle="'ASO'"></headerbom>
    <div class="banner">
      <div class="right" v-if="islogin && !ispass">
        <h1>ASO登录</h1>
        <section>
          <i class="iconfont iconshouji"></i>
          <input type="text" v-model="user" placeholder="请输入您的工作邮箱">
        </section>
        <section>
          <i class="iconfont iconhuaban-a"></i>
          <input type="password" v-model="pass" placeholder="密码（字母、数字、至少6位）" @keyup.enter="btnsubmit">
        </section>
        <p>
          <span @click="islogin = false">忘记密码？</span>
        </p>
        <div @click="btnsubmit">登录</div>
      </div>
      <div class="right" v-if="!islogin && !ispass">
        <h1>忘记密码</h1>
        <section>
          <i class="iconfont iconshouji"></i>
          <input type="text" v-model="user2" placeholder="请输入您的工作邮箱">
        </section>
        <section class="codeinput">
          <i class="iconfont iconhuaban-a"></i>
          <input type="text" v-model="code" placeholder="验证码" @keyup.enter="btnsubmit2">
          <img :src="codeurl" alt="">
          <span @click="loadcode">看不清，换一张</span>
        </section>
        <div @click="btnsubmit2" style="margin-top:10px;">发送到验证邮箱</div>
        <p class="oldpass">
          想起来了<span @click="logoin">&nbsp;立即登录</span>
        </p>
      </div>
      <div class="right" v-if="ispass ">
        <h1>忘记密码</h1>
        <h2>
          请前往<b>{{user2}}</b>查阅来自巨掌移动广告
          平台的邮件，从邮件的提示中重设您的密码。
        </h2>
        <div @click="callbacklogin" style="margin-top:10px;">返回上一步</div>
        <p class="oldpass">
          想起来了<span @click="logoin">&nbsp;立即登录</span>
        </p>
      </div>
    </div>
    <div class="aso_ad">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <div class="aso_adcont">
            <div class="left">
              <h1>
                ASO关键词
                </br>
                搜索效果优化
              </h1>
              <p>
                提成品牌在APP Store关键词搜索结果
                </br>
                的排名增加品牌曝光度
              </p>
            </div>
            <img src="../img/ASO_search2.png" alt="">
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="aso_adcont">
            <div class="left">
              <h1>
                IOS榜单效果优化
              </h1>
              <p>
                提成品牌免费、付费、总榜、分类、
                榜单排名，获得大量自然下载量
              </p>
            </div>
            <img src="../img/ASO_search3.png" alt="">
          </div>

        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="h1_t">
      ASO合作客户
    </div>
    <div class="home_friend">
      <section>
        <div v-for="(ele,index) in frlist" :key="index" :class="{noleft: index % 3 == 0}" v-show="index <12 || (index >= 12 && tofriend)">
          <img :src="ele" alt="">
        </div>
      </section>
    </div>
    <div class="home_fr_mo" @click="tofriend = !tofriend">
      {{!tofriend ?  '查看更多' : '收起'}}
      <i class="iconfont iconxia" v-if="!tofriend"></i>
      <i class="iconfont iconshang" v-if="tofriend"></i>
    </div>
    <footerbom></footerbom>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      tofriend: false,
      frlist: [
        require("../img/ASO_fr1.png"),
        require("../img/ASO_fr2.png"),
        require("../img/ASO_fr3.png"),
        require("../img/ASO_fr4.png"),
        require("../img/ASO_fr5.png"),
        require("../img/ASO_fr6.png"),
        require("../img/ASO_fr7.png"),
        require("../img/ASO_fr8.png"),
        require("../img/ASO_fr9.png"),
        require("../img/ASO_fr10.png"),
        require("../img/ASO_fr11.png"),
        require("../img/ASO_fr12.png"),
        require("../img/ASO_fr13.png"),
        require("../img/ASO_fr14.png"),
        require("../img/ASO_fr15.png"),
        require("../img/ASO_fr16.png"),
        require("../img/ASO_fr17.png"),
        require("../img/ASO_fr18.png"),
        require("../img/ASO_fr19.png"),
        require("../img/ASO_fr20.png"),
        require("../img/ASO_fr21.png"),
        require("../img/ASO_fr22.png"),
        require("../img/ASO_fr23.png"),
        require("../img/ASO_fr24.png"),
      ],
      user: "",
      pass: "",
      tofriend: false,
      islogin: true,
      ispass: false,
      user2: "",
      code: "",
      codeurl:
        "https://account.aso.asoasa.com/Code.aspx?" + new Date().getTime(),
    };
  },
  computed: {},
  components: {},
  created() {},
  destroyed() {},
  mounted() {},
  methods: {
    btnsubmit() {
      if (!this.user) {
        vant.Toast("请输入邮箱");
        return;
      }
      if (!this.pass) {
        vant.Toast("请输入密码");
        return;
      }
      var formdata = new FormData();
      formdata.append("data[User][email]", this.user);
      formdata.append("data[User][password]", this.pass);
      formdata.append("isapi", true);

      this.$https.post(this.$axiosurl + "/login", formdata).then((res) => {
        if (res.indexOf("错误") == -1) {
          vant.Toast("账号或密码不正确");
        } else if (res.indexOf("登录成功") != -1) {
          window.location = "https://aso.asoasa.com";
        } else {
          vant.Toast("登录失败");
        }
      });
    },
    btnsubmit2() {
      if (!this.user2) {
        vant.Toast("请输入邮箱");
        return;
      }
      if (!this.code) {
        vant.Toast("请输入验证码");
        return;
      }
      var formdata = new FormData();
      formdata.append("__EVENTTARGET", "btnSave");
      formdata.append("__VIEWSTATEGENERATOR", "EB622C27");
      formdata.append("data[User][Name]", this.user2);
      formdata.append("data[User][Code]", this.code);
      this.$https.post(this.$axiosurl + "/getpwd", formdata).then((res) => {
        if (res.indexOf(this.user2) == -1) {
          vant.Toast("邮箱或验证码不正确");
          this.codeurl =
            "https://account.aso.asoasa.com/Code.aspx?" + new Date().getTime();
        } else {
          //vant.Toast("从邮件的提示中重设您的密码");
          this.ispass = true;
          //this.islogin = true;
        }
      });
    },
    getcode() {},
    medpass() {
      this.islogin = false;
      this.getcode();
    },
    logoin() {
      this.ispass = false;
      this.islogin = true;
    },
    callbacklogin() {
      this.ispass = false;
      this.islogin = false;
    },
    loadcode() {
      this.codeurl =
        "https://account.aso.asoasa.com/Code.aspx?" + new Date().getTime();
    },
  },
};
</script>

<style lang="less" scoped>
#aso {
  box-sizing: border-box;
  padding-top: 1rem;
  .banner {
    background: url("../img/aso1.png") no-repeat center center;
    background-size: cover;
    height: 5.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .right {
      width: 5rem;
      height: 3.8rem;
      background: #fff;
      border-radius: 0.12rem;
      box-sizing: border-box;
      box-shadow: 0 0 0.12rem rgba(0, 0, 0, 0.3);
      padding: 0 0.3rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      h1 {
        font-size: 0.3rem;
        color: #333;
        margin: 0.3rem 0 0.2rem;
      }
      h2 {
        font-size: 0.18rem;
        color: #666;
        line-height: 0.4rem;
        width: 100%;
        margin: 0.2rem 0;
        b {
          font-size: 0.18rem;
          margin: 0 0.03rem;
          color: #ff6e01;
        }
      }
      span {
        display: block;
        text-align: left;
        color: #999;
        cursor: pointer;
        //width: 1.4rem;
        font-size: 0.18rem;
        &:hover {
          color: @color;
        }
      }
      p {
        width: 100%;
        color: #999;
        font-size: 0.18rem;
        &.oldpass {
          display: flex;
          justify-content: center;
          text-align: center;
          margin-top: 0.2rem;
          span {
            color: @color;
            font-size: 0.18rem;
          }
        }
      }
      section {
        width: 100%;
        height: 0.44rem;
        border-bottom: 0.01rem solid #d3dede;
        position: relative;
        margin-bottom: 0.2rem;
        &.codeinput {
          input {
            width: 1.6rem;
          }
          img {
            width: 1rem;
            height: 0.36rem;
            position: absolute;
            left: 1.7rem;
            top: 0;
          }
          span {
            position: absolute;
            right: 0.24rem;
            top: 0.1rem;
            cursor: pointer;
            color: @color;
            display: block;
            white-space: nowrap;
            font-size: 0.12rem;
            text-align: right;
          }
        }
      }
      i {
        position: absolute;
        left: 0.04rem;
        color: #666;
        z-index: 1;
        top: 50%;
        font-size: 0.16rem;
        transform: translateY(-50%);
      }
      input {
        width: 4.2rem;
        position: absolute;
        height: 0.44rem;
        left: 0;
        right: 0;
        border: none;
        box-sizing: border-box;
        padding-left: 0.31rem;
        font-size: 0.14rem;
        &::-webkit-input-placeholder {
          color: #999;
        }
      }
      div {
        width: 100%;
        height: 0.6rem;
        background: @color;
        text-align: center;
        line-height: 0.6rem;
        color: #fff;
        cursor: pointer;
        border-radius: 0.06rem;
        margin-top: 0.3rem;
        font-size: 0.18rem;
        letter-spacing: 0.04rem;
        &:hover {
          background: #0a92f5;
        }
      }
    }
  }
  .aso_ad {
    width: 100%;
    height: 7rem;
    background: url("../img/aso2.png") no-repeat center center;
    background-size: cover;
    .my-swipe {
      width: 100%;
    }
    .aso_adcont {
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 1rem 0.22rem 0.5rem;
      box-sizing: border-box;
      img {
        width: 3.5rem;
        height: auto;
      }
      h1 {
        font-size: 0.44rem;
        color: @h1;
        line-height: 0.7rem;
        position: relative;
        padding-bottom: 0.16rem;
        margin-bottom: 0.2rem;
        &::after {
          position: absolute;
          content: "";
          width: 0.7rem;
          height: 0.04rem;
          background: @color;
          bottom: 0;
          left: 0;
        }
      }
      p {
        font-size: 0.28rem;
        color: @p;
        line-height: 0.5rem;
      }
    }
  }
  .h1_t {
    font-size: 0.36rem;
    color: @h1;
    text-align: center;
    margin: 0.6rem 0;
    font-weight: bold;
  }
  .home_friend {
    box-sizing: border-box;
    padding: 0rem 0.22rem;
    section {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }
    div {
      border: 0.01rem solid @border;
      border-radius: 0.1rem;
      width: 30%;
      height: 0.94rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 5%;
      box-sizing: border-box;
      margin-bottom: 0.3rem;
      &.noleft {
        margin-left: 0;
      }
      img {
        width: 1.8rem;
        height: auto;
      }
    }
  }
  .home_fr_mo {
    text-align: center;
    font-size: 0.28rem;
    color: #000;
    margin: 0.28rem 0 1rem;
    i {
      margin-left: 0.1rem;
      font-size: 0.22rem;
    }
  }
}
</style>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/page/aso/index.vue